import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WidgetCard from "./WidgetCard";
import { Col, Row, Select } from "antd";
import { OutOfStockMarketShareWidgetProps } from "@/ts/common-types";

const { Option } = Select;

const OosMsDynamics: React.FC<OutOfStockMarketShareWidgetProps> = ({ title, widgetData, maxDate }) => {
  const firstFiveDates = widgetData?.categories?.slice(0, maxDate);

  const myBrandMarketShare = widgetData?.series?.find((s) => s.name === "My Brand Market Share %");
  const myBrandOutOfStock = widgetData?.series?.find((s) => s.name === "My Brand Out of Stock %");
  const defaultSku = widgetData?.skuLists[0] || ""

  const [selectedSkus, setSelectedSkus] = useState<string[]>( defaultSku ? [defaultSku] : []);

  const handleSkuChange = (selected: string[]) => {
    if (selected.length > 1) {
      selected.shift();
    }
    setSelectedSkus(selected);
  };

  const filteredSeries = [
    myBrandMarketShare && {
      ...myBrandMarketShare,
      data: myBrandMarketShare.data.slice(0, maxDate),
      yAxis: 0,
    },
    myBrandOutOfStock && {
      ...myBrandOutOfStock,
      data: myBrandOutOfStock.data.slice(0, maxDate),
      yAxis: 1,
    },
    ...(widgetData?.series
      ?.filter((s) =>
        selectedSkus.length > 0
          ? selectedSkus.some((sku) => s.name.includes(sku))
          : false
      )
      .map((series) => ({
        ...series,
        data: series.data.slice(0, maxDate),
        yAxis: 0,
      })) || []),
  ].filter(Boolean);

  const chartOptions: Highcharts.Options = {
    chart: { type: "column" },
    title: { text: "" },
    xAxis: { categories: firstFiveDates },
    yAxis: [
      { title: { text: "Market Share %" }, },
      { title: { text: "Out of Stock %" }, opposite: true },
    ],
    legend: { layout: "horizontal", align: "center", verticalAlign: "bottom" },
    series: filteredSeries as Highcharts.SeriesOptionsType[],
    credits: {
      enabled: false,
    }
  };

  return (
      <WidgetCard className="my-4">
          <Row className="mb-3" justify="space-between" align="middle">
              <Col span={18}>
                  <h5>{title || "Out of Stock - Market Share Dynamics"}</h5>
              </Col>
              <Col span={5}>
                  <Select
                      mode="multiple"
                      value={selectedSkus}
                      onChange={handleSkuChange}
                      className="w-100"
                      maxTagCount={2}
                      placeholder="Select a competitor SKU"
                  >
                      {widgetData?.skuLists?.map((sku) => (
                          <Option
                              key={sku}
                              value={sku}
                              disabled={
                                  selectedSkus?.length >= 1 &&
                                  !selectedSkus?.includes(sku)
                              }
                          >
                              {sku}
                          </Option>
                      ))}
                  </Select>
              </Col>
          </Row>
          <Row className="d-flex w-100">
              <Col span={24}>
                  <HighchartsReact
                      highcharts={Highcharts}
                      options={chartOptions}
                  />
              </Col>
          </Row>
      </WidgetCard>
  );
};

export default OosMsDynamics;
